/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { TeamInvitationFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type TeamInvitationsQueryVariables = Exact<{
  pending: boolean
}>

export type TeamInvitationsQuery = {
  __typename: "Query"
  teamInvitations?: Array<{
    __typename: "TeamInvitation"
    id: string
    role: string
    invitationAcceptedAt?: string | null
    invitationAccepted: boolean
    invitationRejected?: boolean | null
    acceptInvitationPath: string
    team: {
      __typename: "Team"
      id: string
      name: string
      description?: string | null
      projects?: Array<{
        __typename: "Project"
        id: string
        title: string
        phase?: {
          __typename: "ProjectPhase"
          id: string
          value: string
          label: string
        } | null
      }> | null
    }
    user?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
    invitedBy?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
  }> | null
}

export const TeamInvitationsDocument = gql`
  query TeamInvitations($pending: Boolean!) {
    teamInvitations(pending: $pending)
      @rest(
        type: "TeamInvitation"
        path: "/project-list/teams/invitations?pending={args.pending}"
      ) {
      ...TeamInvitation
    }
  }
  ${TeamInvitationFragmentDoc}
`

/**
 * __useTeamInvitationsQuery__
 *
 * To run a query within a React component, call `useTeamInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamInvitationsQuery({
 *   variables: {
 *      pending: // value for 'pending'
 *   },
 * });
 */
export function useTeamInvitationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    TeamInvitationsQuery,
    TeamInvitationsQueryVariables
  > &
    (
      | { variables: TeamInvitationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TeamInvitationsQuery, TeamInvitationsQueryVariables>(
    TeamInvitationsDocument,
    options
  )
}
export function useTeamInvitationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TeamInvitationsQuery,
    TeamInvitationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    TeamInvitationsQuery,
    TeamInvitationsQueryVariables
  >(TeamInvitationsDocument, options)
}
// @ts-ignore
export function useTeamInvitationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TeamInvitationsQuery,
    TeamInvitationsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  TeamInvitationsQuery,
  TeamInvitationsQueryVariables
>
export function useTeamInvitationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TeamInvitationsQuery,
        TeamInvitationsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  TeamInvitationsQuery | undefined,
  TeamInvitationsQueryVariables
>
export function useTeamInvitationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TeamInvitationsQuery,
        TeamInvitationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    TeamInvitationsQuery,
    TeamInvitationsQueryVariables
  >(TeamInvitationsDocument, options)
}
export type TeamInvitationsQueryHookResult = ReturnType<
  typeof useTeamInvitationsQuery
>
export type TeamInvitationsLazyQueryHookResult = ReturnType<
  typeof useTeamInvitationsLazyQuery
>
export type TeamInvitationsSuspenseQueryHookResult = ReturnType<
  typeof useTeamInvitationsSuspenseQuery
>
export type TeamInvitationsQueryResult = Apollo.QueryResult<
  TeamInvitationsQuery,
  TeamInvitationsQueryVariables
>
